import { render, staticRenderFns } from "./TeachingVideo.vue?vue&type=template&id=699c1d92&scoped=true&"
import script from "./TeachingVideo.vue?vue&type=script&lang=js&"
export * from "./TeachingVideo.vue?vue&type=script&lang=js&"
import style0 from "./TeachingVideo.vue?vue&type=style&index=0&id=699c1d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699c1d92",
  null
  
)

export default component.exports